import {
    useMemo,
} from 'react'
import {
    Navigate,
    useLocation,
} from 'react-router-dom'
import {
    SkyNetRouteConfigObject,
    useSkyNetRoutes,
} from 'app/SkyNetRoutes'
import {
    RateCardsTabs,
} from 'app/enums/domain.enums'
import {
    CommonRoutes,
} from 'app/enums/common.enums'

import useRatesRoutes from 'app/SkyNetRoutes/hooks/useRatesRoutes'
import BaseLeaseBulkEdit from '../BaseLease/BaseLeaseBulkEdit'
import OtherLaneFeesBulkEdit from '../OtherLaneFees/OtherLaneFeesBulkEdit'
import AdditionalFeesBulkEdit from '../AdditionalFees/AdditionalFeesBulkEdit'
import MarginsBulkEdit from '../Margins/MarginsBulkEdit'
import LogisticsCostsBulkEdit from '../LogisticsCosts/LogisticsCostsBulkEdit'
import RegionalServiceAvailabilityBulkEdit from '../RegionalServiceAvailability/RegionalServiceAvailabilityBulkEdit'

export default function RateCardsBulkEdit() {
    const {
        state,
    } = useLocation()

    const {
        CRateCards: RateCardsRoutes,
    } = useRatesRoutes()

    const routesConfig: SkyNetRouteConfigObject<RateCardsTabs> = useMemo(() => {
        return {
            [RateCardsTabs.BaseLease]: <BaseLeaseBulkEdit onClose={
                RateCardsRoutes.BaseLease.navigate
            }
            />,
            [RateCardsTabs.OtherLaneFees]: <OtherLaneFeesBulkEdit onClose={
                RateCardsRoutes.OtherLaneFees.navigate
            }
            />,
            [RateCardsTabs.AdditionalFees]: <AdditionalFeesBulkEdit onClose={
                RateCardsRoutes.AdditionalFees.navigate
            }
            />,
            [RateCardsTabs.Margins]: <MarginsBulkEdit onClose={
                RateCardsRoutes.Margins.navigate
            }
            />,
            [RateCardsTabs.LogisticsCosts]: <LogisticsCostsBulkEdit onClose={
                RateCardsRoutes.LogisticsCosts.navigate
            }
            />,
            [RateCardsTabs.RegionalServiceAvailability]:
    <RegionalServiceAvailabilityBulkEdit onClose={
        RateCardsRoutes.RegionalServiceAvailability.navigate
    }
    />,
            [CommonRoutes.Slash]: (
                <Navigate
                    to={
                        state?.from.split(CommonRoutes.Slash).at(-1)
                        || RateCardsRoutes.BaseLease.route
                    }
                    replace
                />
            ),
        }
    }, [
        state?.from,
        RateCardsRoutes,
    ])

    return useSkyNetRoutes({
        routesConfig,
    })
}
